import service from '@/api/roleGroup';
import {handleError} from '@/state/generators/helpers';

export const state = {
    loadingPermissions: false,
    permissionTree: [],
    service: service('roleGroups')
}

export const getters = {
    permissionLoading: (state) => {
        return !!state.loadingPermissions;
    },

    permissionTree: (state) => {
        return JSON.parse(JSON.stringify(state.permissionTree))
    },
}

export const mutations = {
    'SET_LOADING_PERMISSIONS': function (state, boolean = true) {
        state.loading = boolean;
    },

    'SET_PERMISSION_TREE': function (state, data = []) {
        state.permissionTree = data;
    },
}

export const actions = {
    fetchPermissionTree: ({ commit }, id) => {
        commit('app/SET_LOADING', true, {root: true})
        commit('SET_LOADING_PERMISSIONS', true)

        return state.service.fetchRoles(id).then(response => {
            commit('SET_PERMISSION_TREE', response.data);
            commit('app/SET_LOADING', false, {root: true})
            commit('SET_LOADING_PERMISSIONS', false)
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        });
    },

    saveRoles: function ({commit}, {id, roles}) {
        commit('app/SET_LOADING', true, {root: true})
        commit('SET_LOADING_PERMISSIONS', true)

        return state.service.saveRoles(id, roles).then(response => {
            commit('SET_PERMISSION_TREE', response.data)
            commit('app/SET_LOADING', false, {root: true})
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_LOADING_PERMISSIONS', false)
            return response.data;
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
